"use client";

import { useBookingDrawer } from "@/lib/booking-context";
import { getBookingSource } from "@/lib/booking-source";

// UI actions an editor can attach to a button via the `action` field.
// When set, the button fires the action instead of navigating.
export type BlokAction = "open_booking";

export function useTriggerAction() {
  const { setOpen: setBookingOpen } = useBookingDrawer();
  // Pass the click event so the booking source is derived from the section
  // the button lives in — no per-module wiring needed.
  return (
    action: string | undefined | null,
    event?: { currentTarget: Element },
  ) => {
    if (action === "open_booking") {
      setBookingOpen(true, getBookingSource(event?.currentTarget));
      return true;
    }
    return false;
  };
}
